// import React, { useEffect } from 'react';
// // import FingerprintJS from '@fingerprintjs/fingerprintjs';
// // import axios from 'axios';
// // import { ServerPath } from '../../Constant';

// const DeepLinkRedirectPage = () => {

//     const params = new URLSearchParams(window.location.search);
//     const encodedData = params.get('data');


//     // async function init() {
//     //   // Generate fingerprint
//     //   const fp = await FingerprintJS.load();
//     //   const result = await fp.get();
//     //   const visitorId = result.visitorId;

//     //   // Store pending deep link in backend
//     //   await axios.post(`${ServerPath}/pending-links/store-pending-link`, {
//     //     visitorId,
//     //     data: encodedData,
//     //   });
//     // }
//     // Moved these two lines outside of the useEffect
//     const appStoreUrl = 'https://apps.apple.com/in/app/narmada-parikrama/id6648785119';
//     const playStoreUrl = `https://play.google.com/store/apps/details?id=com.parikrama.app&referrer=${encodedData}`;

//     useEffect(() => {
//         // init();
//         const userAgent = navigator.userAgent || navigator.vendor || window.opera;

//         // Check for iOS devices
//         if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
//             window.location.href = appStoreUrl;
//         } 
//         // Check for Android devices and fallback for others
//         else {
//             window.location.href = playStoreUrl;
//         }
//     }, []); // The empty array ensures this runs only once

//     // Now the return statement can see the variables
//     return (
//         <div style={{ padding: '20px', fontFamily: 'sans-serif', textAlign: 'center' }}>
//             <h1>Redirecting to the app store...</h1>
//             <p>If you are not redirected automatically, please click one of the links below:</p>
//             <a href={appStoreUrl}>Download on the App Store</a>
//             <br /><br />
//             <a href={playStoreUrl}>Get it on Google Play</a>
//         </div>
//     );
// };

// export default DeepLinkRedirectPage;


import { useEffect, useState } from 'react';
import play from '../../../src/assets/images/playstore.png';
import app from '../../../src/assets/images/appstore.png';
import parikrama from '../../../src/assets/images/parikramaNew.png';
import Background from '../../../src/assets/images/bigBackground.png';
import axios from 'axios';
import { ServerPath } from '../../Constant';

const DeepLinkRedirectPage = () => {
    const [redirectData, setRedirectData] = useState(null);
    const params = new URLSearchParams(window.location.search);
    const encodedData = params.get('data');
    useEffect(() => {

        console.log('🔍 [REDIRECT] Received encodedData:', encodedData);

        let referrerMobile = '';
        let contentType = '';
        let contentId = '';

        if (encodedData) {
            try {
                const decoded = atob(encodedData);
                console.log('🔓 [REDIRECT] Decoded string:', decoded);
                const decodedParams = new URLSearchParams(decoded);
                referrerMobile = decodedParams.get('referredBy') || '';
                contentType = decodedParams.get('entityType') || '';
                contentId = decodedParams.get('entityId') || '';
                console.log('📋 [REDIRECT] Extracted data:', { referrerMobile, contentType, contentId });
            } catch (e) {
                console.error('❌ [REDIRECT] Failed to decode:', e);
            }
        }

        const sessionId = `${Date.now()}_${Math.random().toString(36).substring(7)}`;
        const playStoreReferrer = `utm_source=referral&utm_campaign=${referrerMobile}&session_id=${sessionId}&content_type=${contentType}&content_id=${contentId}`;

        const appStoreUrl = 'https://apps.apple.com/in/app/narmada-parikrama/id6648785119';
        const playStoreUrl = `https://play.google.com/store/apps/details?id=com.parikrama.app&referrer=${encodeURIComponent(playStoreReferrer)}`;

        setRedirectData({
            appStoreUrl,
            playStoreUrl,
            referrerMobile,
            contentType,
            playStoreReferrer
        });
    }, []);

    const handleAppleRedirection = async () => {

        // Store pending deep link in backend
        await axios.post(`${ServerPath}/pending-links/store-pending-link`, {
            visitorId: 'AppleUser', // Replace with actual visitorId when fingerprinting is implemented
            data: encodedData,
        });
       window.location.href = redirectData.appStoreUrl

    }

    if (!redirectData) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.8) 100%)',
                fontFamily: 'sans-serif',
                color: '#fff'
            }}>
                <h1>Loading / लोड हो रहा है...</h1>
            </div>
        );
    }

    return (
        <div style={{
            minHeight: '100vh',
            background: `linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.75) 100%), url(${Background})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '40px 20px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
            textAlign: 'center',
            color: '#fff'
        }}>
            <div style={{
                maxWidth: 400,
                width: '100%'
            }}>
                {/* App Logo */}
                <div style={{
                    marginBottom: 30
                }}>
                    <img
                        src={parikrama}
                        alt="My Parikrama"
                        style={{
                            width: 100,
                            height: 100,
                            borderRadius: 22,
                            boxShadow: '0 8px 24px rgba(0,0,0,0.3)'
                        }}
                    />
                </div>

                {/* Welcome Text */}
                <h1 style={{
                    fontSize: 28,
                    fontWeight: 600,
                    marginBottom: 20,
                    lineHeight: 1.3
                }}>
                    Welcome to My Parikrama
                </h1>

                {/* Description */}
                <p style={{
                    fontSize: 16,
                    lineHeight: 1.6,
                    color: 'rgba(255,255,255,0.9)',
                    marginBottom: 30,
                    padding: '0 10px'
                }}>
                    Discover the hidden beauty of India's sacred teerthas through immersive visuals, stories, and guided experiences.
                </p>

                {/* Call to Action */}
                <p style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: '#FF8C42',
                    marginBottom: 25,
                    lineHeight: 1.5
                }}>
                    Choose your app store and step into the world of My Parikrama
                </p>

                {/* App Store Buttons */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 15,
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>

                    <a href={redirectData.playStoreUrl}
                        onClick={() => {
                            console.log('🎯 [USER_CLICK] Play Store button', redirectData.playStoreUrl);
                        }}
                        style={{
                            display: 'block',
                            textDecoration: 'none',
                            transition: 'transform 0.2s'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    >
                        <img
                            src={play}
                            alt="Get it on Google Play"
                            style={{
                                height: 50,
                                width: 'auto'
                            }}
                        />
                    </a>


                    <div 
                    // href={redirectData.appStoreUrl}
                        onClick={handleAppleRedirection}
                        style={{
                            display: 'block',
                            textDecoration: 'none',
                            transition: 'transform 0.2s'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    >
                        <img
                            src={app}
                            alt="Download on App Store"
                            style={{
                                height: 50,
                                width: 'auto'
                            }}
                        />
                    </div>
                </div>

                {/* Optional: Dimensions indicator (like in your image) */}
                {/* <div style={{
          marginTop: 30,
          fontSize: 12,
          color: '#4A9EFF',
          fontWeight: 600,
          padding: '8px 16px',
          background: 'rgba(74, 158, 255, 0.15)',
          borderRadius: 6,
          display: 'inline-block'
        }}>
          175 × 65
        </div> */}
            </div>

            {/* Debug Info (for development only) */}
            {/* <div
        style={{
          marginTop: 40,
          padding: 15,
          background: 'rgba(255,255,255,0.1)',
          borderRadius: 8,
          textAlign: 'left',
          fontSize: 12,
          fontFamily: 'monospace',
          maxWidth: 400
        }}
      >
        <strong>🔧 Debug Info (remove in production):</strong>
        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', marginTop: 10 }}>
          {JSON.stringify(
            {
              referrerMobile: redirectData.referrerMobile,
              contentType: redirectData.contentType,
              playStoreReferrer: redirectData.playStoreReferrer,
            },
            null,
            2
          )}
        </pre>
      </div> */}
        </div>
    );
};

export default DeepLinkRedirectPage;
